/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm-dialog ref="confirm"></confirm-dialog>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm-dialog ref="confirm"></confirm-dialog>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm
 * }
 */

import DataCard from '@/app-theme/components/common/DataCard.vue'

export default {
  name      : 'ConfirmDialog',
  components: {DataCard},
  directives: {},
  mixins    : [],
  props     : [],
  data() {
    return {
      dialog           : false,
      resolve          : null,
      reject           : null,
      answer           : '',
      input            : '',
      reason           : '',
      selectedReason   : null,
      selectedTime     : null,
      message          : '',
      title            : '',
      subTitle         : '',
      timeDialogVisible: false,
      defaultOptions   : {
        icon         : 'mdi-alert',
        color        : 'error',
        dense        : false,
        width        : 550,
        persistent   : true,
        dark         : false,
        coloredBorder: true,
        input        : false,
        validate     : false,
        reason       : false,
        reasons      : null,
        selectTime   : false,
        button       : {
          no : {title: this.$t('Common.Button.No')},
          yes: {title: this.$t('Common.Button.Yes')}
        }
      },
      options: {}
    }
  },
  computed: {
    isNotValid() {
      const validate = (this.options.validate && String(this.answer).toUpperCase() !== String(this.options.validate.answer).toUpperCase())
      const time = this.options.selectTime && !this.selectedTime
      const input = !this.input && !this.input?.length

      if (this.options.validate && this.options.selectTime) {
        return validate || time
      } else if (this.options.validate) {
        return validate
      } else if (this.options.selectTime) {
        return time
      } else if (this.options.input) {
        return input
      }
      return false
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    open(title, subTitle, message, options = {}) {
      this.answer = ''
      this.reason = ''
      this.input = ''
      this.selectedReason = null
      this.selectedTime = options.startedTimeAt || ''
      this.selectTime = false
      this.timeDialogVisible = false
      this.title = title
      this.subTitle = subTitle
      this.message = message
      this.options = {...this.defaultOptions, ...options}
      this.dialog = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },

    confirm() {
      if (this.options.validate && String(this.answer).toUpperCase() !== String(this.options.validate.answer).toUpperCase()) return
      const reason = this.options.reason && this.selectedReason && this.selectedReason.Id > 0 ? this.selectedReason.Name : this.options.reason && this.reason.trim() ? this.reason.trim() : false
      const time = this.options.selectTime && this.selectedTime ? this.selectedTime : false
      const input = this.options.input && this.input?.length ? this.input : null

      if (this.options.reason && this.options.selectTime) {
        this.resolve(time)
      } else if (this.options.reason) {
        this.resolve(reason)
      } else if (this.options.selectTime) {
        this.resolve(time)
      } else if (this.options.input) {
        this.resolve(input)
      } else {
        this.resolve(true)
      }

      this.close()
    },

    cancel() {
      this.resolve(false)
      this.close()
    },

    close() {
      this.dialog = false
    }
  }
}
